import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export type KeyValueValueTone =
  | "normal"
  | "danger"
  | "warning"
  | "success"
  | "hyperlink"

type KeyValueProps = {
  label: ReactNode
  value: ReactNode
  valueTone?: KeyValueValueTone
  className?: string
}

const valueToneClasses: Record<KeyValueValueTone, string> = {
  normal: "text-foreground",
  danger: "text-destructive",
  warning: "text-warning",
  success: "text-success",
  hyperlink: "text-primary underline-offset-4 hover:underline",
}

export function KeyValue({
  label,
  value,
  valueTone = "normal",
  className,
}: KeyValueProps) {
  return (
    <span className={cn("inline-flex items-center gap-2 text-sm", className)}>
      <span className="text-muted-foreground">{label}</span>
      <span className={valueToneClasses[valueTone]}>{value}</span>
    </span>
  )
}
